export const TokenType = {
  ACCESS: 'access',
  TWOFACTOR: 'twofa',
}